import { ISaveFeeRange } from "../../Interfaces";

export function AddNewFeeRange(this: any): ISaveFeeRange {
  return {
    id: this.id ?? -1,
    feeId: this.feeId,
    fromAmount: this.fromAmount ?? 0,
    toAmount: this.toAmount ?? 0,
    noOfFee: this.noOfFee,
    amount: this.amount,
    doubleAmount: this.doubleAmount,
  };
}

export function AddNewFeeRangeSW(this: any): ISaveFeeRange {
  return {
    id: this.id ?? -1,
    feeId: this.feeId,
    fromAmount: this.fromAmount ?? 0,
    toAmount: this.toAmount ?? 0,
    noOfFee: this.noOfFee ?? 0,
    amount: this.amount ?? 0 ,
    doubleAmount: this.doubleAmount ?? 0,
    baseAmount: this.baseAmount ?? 0,
    feeRate: this.feeRate,
    reminderFee: this.reminderFee ?? 0,
    collectionFee: this.collectionFee ?? 0,
    calculationType: this.calculationType,
  };
}
